var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSymbolYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 34,
    viewBox: "0 0 64 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.48 5.59905L32 0L37.52 5.59905L32 11.1981L26.48 5.59905ZM16.44 1.54177L29.84 15.1337V34H24.6L21.2 30.957V17.9332L13.04 9.65633H3.4L0 6.20764V1.54177H16.44ZM64 1.54177V6.20764L60.6 9.65633H50.96L42.8 17.9332V30.957L39.4 34H34.16V15.1337L47.56 1.54177H64ZM0 13.7136H10.88L16.88 19.4344V24.4248H10.4L7.68 21.8282H3.4L0 18.3795V13.7136ZM47.12 19.4344L53.12 13.7136H64V18.3795L60.6 21.8282H56.32L53.6 24.4248H47.12V19.4344Z",
    fill: "#E6C100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolYellow);
export default __webpack_public_path__ + "static/media/logo-symbol-yellow.b18b74c46f4edd2a1b0af5764c8b9e61.svg";
export { ForwardRef as ReactComponent };